export { Component } from "./confirm";
export { show } from "./confirm.model";
export type { PayloadType } from "./types";
